import React from "react";
import "../styles/oneCCDP.css";

const ContactSection: React.FC = () => {
  return (
    <div className="contact-section">
      <div className="contact-item">
        <p className="contact-question">Can't access your account?</p>
        <p className="contact-answer">
          Your district manages login access. Please contact your IT Help Desk
          for support.
        </p>
      </div>

      <div className="contact-separator"></div>

      <div className="contact-item">
        <p className="contact-question">
          Having trouble viewing the dashboard?
        </p>
        <p className="contact-answer">
          Please contact{" "}
          <a href="mailto:ccdp@cccd.edu" className="contact-email">
            ccdp@cccd.edu
          </a>{" "}
          for assistance.
        </p>
      </div>
    </div>
  );
};

export default ContactSection;
